let initDone = false;
let initInFlight = null;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function waitForChargebeeGlobal({ timeoutMs = 8000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    if (window.Chargebee) return window.Chargebee;
    await sleep(50);
  }
  return null;
}

function ensureChargebeeInit(Chargebee) {
  if (initDone) return;

  const site = process.env.REACT_APP_CB_SITE;
  const publishableKey = process.env.REACT_APP_CB_PUBLISHABLE_KEY;

  if (!site || !publishableKey) {
    throw new Error("Missing REACT_APP_CB_SITE or REACT_APP_CB_PUBLISHABLE_KEY");
  }

  Chargebee.init({ site, publishableKey });
  initDone = true;
}

export async function getChargebee() {
  if (initInFlight) return initInFlight;

  initInFlight = (async () => {
    const Chargebee = await waitForChargebeeGlobal();
    if (!Chargebee) return null;
    ensureChargebeeInit(Chargebee);
    return Chargebee;
  })();

  return initInFlight;
}

export async function getChargebeeSdk() {
  const Chargebee = await getChargebee();
  if (!Chargebee) return null;

  const instance = typeof Chargebee.getInstance === "function" ? Chargebee.getInstance() : null;
  return { Chargebee, instance };
}

export async function openChargebeeCheckout({ hostedPage, onSuccess, onClose, layout }) {
  const sdk = await getChargebeeSdk();
  if (!sdk) return false;

  const { Chargebee, instance } = sdk;

  // Some Chargebee.js setups expose `openCheckout` on the global,
  // others only on the instance returned by `getInstance()`.
  const openCheckout =
    (typeof Chargebee.openCheckout === "function" && Chargebee.openCheckout.bind(Chargebee)) ||
    (instance && typeof instance.openCheckout === "function" && instance.openCheckout.bind(instance));

  if (!openCheckout) return false;

  openCheckout({
    // Chargebee.js expects a function that returns a promise resolving
    // to a hosted page object (with at least `id` and `url`).
    hostedPage,
    success: onSuccess,
    close: onClose,
    ...(layout && { layout }),
  });

  return true;
}

